/**
 * 見積書 / 請求書の「発行日・期限」を編集できる人の判定 (firestore.rules の canEditDocumentDates と同じ定義)。
 *
 * 許可する人:
 *  - GoEnHub 管理者 (owner)
 *  - 営業部のリーダー・社員
 *  - 書類 (見積書 / 請求書) の作成者
 *  - 商談の作成者
 *  - 商談の担当者 (担当者 / 個別説明担当者。見積書は外部SA (salesAgentUid) も含む)
 *
 * 請求書は外部SA (level='external') を常に不可とする。
 * UI でボタンを出す/出さないの判定に使う。最終的な拒否は firestore.rules が行う。
 */
import type { Deal } from '@goenhub/shared';

import type { AuthUser } from '@/hooks/useAuth';

type DealLike = Pick<
  Deal,
  'createdBy' | 'assigneeUid' | 'briefingAssigneeUid' | 'salesAgentUid'
>;

export function canEditDocumentDates(
  user: AuthUser | null,
  deal: DealLike,
  doc: { createdBy?: string | null },
  kind: 'quote' | 'invoice',
): boolean {
  if (!user) return false;
  if (kind === 'invoice' && user.level === 'external') return false;
  if (user.role === 'owner' || user.isOwner) return true;
  if (user.dept === 'sales' && (user.level === 'leader' || user.level === 'employee')) {
    return true;
  }
  const uid = user.uid;
  if (doc.createdBy === uid) return true;
  if (deal.createdBy === uid) return true;
  if (deal.assigneeUid === uid) return true;
  if (deal.briefingAssigneeUid === uid) return true;
  if (kind === 'quote' && deal.salesAgentUid === uid) return true;
  return false;
}

export const DOCUMENT_DATE_PERMISSION_DENIED_MESSAGE =
  '日付を編集する権限がありません (管理者・営業部・書類の作成者・商談の作成者/担当者のみ編集できます)';
